// Core
// import PropTypes from "prop-types";
// import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import Card from "@mui/material/Card";

// Redux
// import { useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";

// Table
import { useGetFlexibilityBidsQuery } from "state/communities/communitiesApiSlice";
// import DataTableUpgrade from "./DataTableUpgrade";
import DataTable from "./DataTableUpgrade";
// import MembersDataTable from "../../ManageMembers/List/DataTable";
import Box from "../../../components/Atoms/Box";
import HelpFloatingButton from "../../../components/HelpFloatingButton";
import TypographyV1 from "../../../components/Atoms/Typography/TypographyV1";
// import Flexibility from "../../ManageCommunities/Single/Flexibility";
// import LoadingCard from "../../../components/Cards/LoadingCard";
// NOTE: Add this import to fetch your Bids

function ListFlexibility() {
  // Example: we get the "currentCommunity" from Redux,
  // but we actually need a businessPartnerId to fetch bids.
  // If your businessPartnerId is stored in the community, read it, or just hard-code it for now.
  const selectedCommunity = useSelector(selectCurrentCommunity);

  const { t } = useTranslation(["flexibility"]);

  const { data: bids, isLoading: queryIsLoading } = useGetFlexibilityBidsQuery(
    selectedCommunity?.id
  );

  let table;
  if (queryIsLoading) {
    table = <div>{t("loading")}</div>;
  } else if (bids?.length > 0) {
    table = <DataTable data={bids} />;
  } else {
    table = <DataTable data={[]} />;
  }

  return (
    <Box my={3}>
      <HelpFloatingButton helpScreen="member-list" />
      <Card>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
          <Box lineHeight={1}>
            <TypographyV1 variant="h5" fontWeight="medium">
              {t("title")}
            </TypographyV1>
            <TypographyV1 variant="button" fontWeight="regular" textColor="text">
              {t("subtitle")}
            </TypographyV1>
          </Box>
        </Box>
        {table}
      </Card>
    </Box>
  );
}

// ListFlexibility.propTypes = {};

ListFlexibility.defaultProps = {
  setIsLoading: () => {},
};

export default ListFlexibility;
